module.exports = __webpack_public_path__ + "img/part_box3_3.710cfd29.jpg";